import formWithTreeToFormQuestions from '@opsbase/lib-form/convert/formWithTreeToFormQuestions';
import DeviceType from '@opsbase/lib-general/DeviceType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import PerformController from '@opsbase/react-ctrl-perform/PerformController';
import useOpSubmit from '@opsbase/react-gql-hooks/op/useOpSubmit';
import useOpUpdate from '@opsbase/react-gql-hooks/op/useOpUpdate';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useNav from '@opsbase/web-nav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import OpPerform from '@opsbase/web-opform-perform';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useState } from 'react';
export function OpPerformProcessDialog(props) {
    var _a, _b;
    const { replaceTo } = useNav();
    const { raise } = useNotificationActions();
    const [op] = useState(props.op);
    const [saving, setSaving] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const updateOp = useOpUpdate();
    const submitOp = useOpSubmit();
    const _doUpdate = useMemo(() => {
        return debounce(async (formWithTree) => {
            setSaving(true);
            await updateOp({
                id: op.id,
                patch: { form: formWithTreeToFormQuestions(formWithTree) },
            });
            setSaving(false);
        }, 1000, {
            trailing: true,
            leading: false,
        });
    }, [op, updateOp]);
    const _doSubmit = useMemo(() => async (form, staff, userImage) => {
        setSubmitting(true);
        return raise(submitOp({
            id: op.id,
            submittedById: staff === null || staff === void 0 ? void 0 : staff.id,
            completedOnDeviceType: DeviceType.WEBAPP,
            userImage,
        }).then(() => 
        // WAIT A COUPLE OF SECONDS BEFORE SENDING THE USER TO THE VIEW PAGE
        // THIS GIVES IMAGES A CHANCE TO GET SORTED IN AWS
        new Promise(resolve => {
            setTimeout(() => {
                resolve();
                setSubmitting(false);
                replaceTo(Pages.OP_VIEW, { id: op.id });
            }, 2000);
        })), i18n.t('op-successfully-submitted'));
    }, [op.id, raise, replaceTo, submitOp]);
    const handleAddConversation = useCallback(async (conversationId) => {
        await updateOp({
            id: op.id,
            patch: {
                conversations: [...op.conversations, conversationId],
            },
        });
    }, [op, updateOp]);
    const handleSubmit = useCallback(_doSubmit, [_doSubmit]);
    const handleUpdate = useCallback((formWithTree) => {
        setSaving(true);
        _doUpdate(formWithTree);
    }, [_doUpdate]);
    return (React.createElement(Dialog, { closable: !submitting && !saving, size: DialogSize.X800_YFULL, padded: false },
        React.createElement(PerformController, { id: op.id, title: op.title, saving: saving, placeId: (_a = op.place) === null || _a === void 0 ? void 0 : _a.id, placeTitle: (_b = op.place) === null || _b === void 0 ? void 0 : _b.title, form: op.getParsedForm(), isSubmitted: !!op.actualComplete, mode: !!op.actualComplete || op.canBePerformedOnlyOnNative ? 'view' : 'edit', isScoreEnabled: op.isScoreEnabled, isScorePublic: op.isScorePublic, isGradingPublic: op.isGradingPublic, allowIssuesAndNotes: op.allowIssuesAndNotes, gradingMethod: op.gradingMethod, canBePerformedOnlyOnNative: op.canBePerformedOnlyOnNative, onSubmit: handleSubmit, onUpdate: handleUpdate, onAddConversation: handleAddConversation },
            React.createElement(OpPerform, null))));
}
export default OpPerformProcessDialog;
